module["exports"] = [
  "0####-#-####",
  "0###-##-####",
  "0##-###-####",
  "0#-####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ja/phone_number/formats.js
// module id = 860
// module chunks = 0